import { Component, type ReactNode } from 'react';
import { getStartupMessages } from '@/locales/startup';

/** Deliberately independent of providers, theme, storage and UI libraries. */
export class StartupBoundary extends Component<
  { children: ReactNode; failed?: boolean },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error) {
    console.error('[StartupBoundary]', error);
  }

  render() {
    if (this.state.failed || this.props.failed) {
      const [title, description, reload] = getStartupMessages(
        document.documentElement.lang || navigator.language,
      );
      return (
        <main
          role="alert"
          style={{ padding: 24, fontFamily: 'sans-serif', lineHeight: 1.6 }}
        >
          <h1 style={{ fontSize: 20 }}>{title}</h1>
          <p>{description}</p>
          <button type="button" onClick={() => window.location.reload()}>
            {reload}
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
